import { render } from "./ListActivitats.vue?vue&type=template&id=55fe006d&scoped=true"
import script from "./ListActivitats.vue?vue&type=script&lang=js"
export * from "./ListActivitats.vue?vue&type=script&lang=js"

import "./ListActivitats.vue?vue&type=style&index=0&id=55fe006d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55fe006d"]])

export default __exports__